<template>
  <div class="activityDialog">
    <el-dialog
      top="3%"
      width="100%"
      :title="dialogTitle"
      :visible.sync="visible"
      :close-on-click-modal="false"
      :before-close="closeEvent"
    >
      <el-form ref="dialogForm" :model="form" label-width="120px">
        <el-row>
          <el-col :span="24">
            <el-form-item label="物流单号" prop="name">
              <el-input
                v-model="form.ydh"
                placeholder="请输入物流单号"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeEvent()">取 消</el-button>
        <el-button type="primary" @click="submitData()">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import config from "@/assets/api/config.js";
export default {
  data() {
    return {
      visible: false,
      dialogTitle: "发货",
      form: {
        id: "", //订单ID
        ydh: "",
      },
      config,
    };
  },
  components: {},
  methods: {
    submitData() {
      let params = { ...this.form };
      this.getAjax("api/order/fahuo", params, "post").then(() => {
        this.$message.success("操作成功");
        this.closeEvent();
        this.$emit("search");
      });
    },
    closeEvent() {
      this.visible = false;
      this.dialogTitle = "发货";
      this.form = {
        id: "", //订单ID
        ydh: "",
      };
    },
  },
  mounted() {},
};
</script>

<style lang="less">
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9 !important;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
</style>
